import { render, staticRenderFns } from "./ToggleSidebarButton.vue?vue&type=template&id=03a034a0&scoped=true"
import script from "./ToggleSidebarButton.vue?vue&type=script&lang=js"
export * from "./ToggleSidebarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a034a0",
  null
  
)

export default component.exports